import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NotificationsService, SimpleNotificationsComponent } from 'angular2-notifications';
import { UUID } from 'angular2-uuid';

import { TitleService } from './title.service';
import { Title } from './model/title';
import { Eventlog } from './model/eventlog';
import { TitleRequest } from './model/titleRequest';

import { EventlogService } from './eventlog.service';
import { TitleRequestService } from './titleRequest.service';
import { UserService } from '../user/user.service';
import { User } from '../user/user';
import { DPCustomerService } from '../portalv1/dp-customer.service';
import { DPAccountService } from '../portalv1/dp-accounts.service';
import { DPCustomer } from '../portalv1/dp-customer';
import { DPAccount } from '../portalv1/dp-account';
import { Markets } from './markets';
import { Market } from './model/market';




@Component({
    templateUrl: 'title-create.component.html'
})

export class TitleCreateComponent implements OnInit {
    titleToDisplay: Title;
    titleRequest = new TitleRequest();
    errorResponse: any;
    notificationTitle: any;
    notificationContent: any;
    notificationType: any;
    deleting = false;
    displayDet = false;
    showNoteForm = false;
    showRequestForm = false;
    log = new Eventlog;
    currentUser: User;
    allUsers: User[];
    allNotes: any[];
    customerList: DPCustomer[];
    custAccountList: DPAccount[];
    allAccountList: DPAccount[];
    allRequests: any;
    requestAccountId: number;
    custSelected = false;
    markets: Market[] = Markets;
    currentDate = new Date();
    dataStartFrom: Date;
    entry_date: Date;
    showDataStartPicker: boolean = false;
    showPdrStartPicker: boolean = false;
    showEntryDatePicker: boolean = false;

    constructor(
        private userService: UserService,
        private accountService: DPAccountService,
        private customerService: DPCustomerService,
        private titleService: TitleService,
        private _service: NotificationsService,
        private router: Router,
        private route: ActivatedRoute,
        private eventlogService: EventlogService,
        private titleRequestService: TitleRequestService

    ) { }
    ngOnInit() {
        this.route.params.forEach((params: Params) => {

            const content_id = params['content_id'];
            if (content_id != null) {
                // get title for content id in url
                this.titleService.getTitle(content_id)
                    .then(res => this.displayDetails(res.titles[0]))
                    .catch(error => this.errorHandler(error));
                // get all users
                this.userService.getUsers()
                    .then(response => { this.allUsers = response.user; this.assignUserNamesToNotes(); })
                    .catch(error => this.errorHandler(error));
                // Get all accounts by using 0 for customer id
                this.accountService.getAccountsByCompanyId(0)
                    .then(res => { this.allAccountList = res.user_accounts; this.setAccountNamesToRequests(); })
                    .catch(error => this.errorHandler(error));
                // Get the current user to get user id for posting notes
                this.userService.getOwnUser().then(u => this.currentUser = u);
            }
            else {
                const uuid = UUID.UUID();
                this.titleToDisplay = new Title();
                this.titleToDisplay.content_id = uuid;
                this.titleToDisplay.catalog_state = 1;
                this.titleToDisplay.manual_addition = 0;
                this.titleToDisplay.production_state = 1;
            }
        });

    }
    /**
     * Method used to set account names to each title request
     */
    setAccountNamesToRequests() {
        if (this.allAccountList && this.titleToDisplay.content_requests) {
            this.allRequests = this.titleToDisplay.content_requests;
            for (let request of this.allRequests) {
                request = this.getAccountNameForRequest(request);
            }
        }
    }
    /**
     * Assigns the account name to the given request from the allAccountList
     */
    getAccountNameForRequest(request: any) {
     //   console.log('all accounts', this.allAccountList);
        const account = this.allAccountList.find(account => account.account_id == (Number)(request.account_id));
        if (account){
            request.accountName = account.account_name;
         } else {

             request.accountName = request.account_id;
         }
       //    console.log('request', request);
        return request;
    }
    /**
     * Creates a list of new objects from the eventlog of the displayed titles which includes the names of the authors of the notes
     */
    assignUserNamesToNotes() {
        if (this.allUsers && this.titleToDisplay.content_title_eventlog) {
            this.allNotes = this.titleToDisplay.content_title_eventlog;
            for (let note of this.allNotes) {
                note = this.getAuthorForNote(note);
            }
        }
    }
    /**
     * Gets the name of the author for the given note
     */
    getAuthorForNote(note: any) {
        const user = this.allUsers.find(u => u.user_id == note.event_owner_id);
        note.author = user.first_name + ' ' + user.last_name;
    //    console.log(note);
        return note;
    }
    /**
     * Formats dats to be able to be displayed in <date> tag and sets titleToDisplay to given title
     */
    displayDetails(title: Title) {
        this.titleToDisplay = title;
        if (this.titleToDisplay.content_title_eventlog == null) {
            this.titleToDisplay.content_title_eventlog = new Array<Eventlog>();
        }
        if (this.titleToDisplay.content_requests == null) {
            this.titleToDisplay.content_requests = new Array<TitleRequest>();
        }
        this.assignUserNamesToNotes();
        this.setAccountNamesToRequests();
        this.displayDet = true;
    }
    /**
     * Generic error handler for all errors
     */
    errorHandler(error: any) {
        this.notificationType = 'error';
        this.notificationTitle = 'Error';
        const jsonErrorBody = JSON.parse(error._body);
        this.notificationContent = jsonErrorBody.error.message;
        this.createNotification();
    }
    /**
     * toggles the visibility of the form to post a new note
     */
    displayNoteForm() {
        if (this.showNoteForm) {
            this.showNoteForm = false;
        } else {
            this.showNoteForm = true;
        }
    }
    /**
     * Posts a new note for the current title with the logged in users id
     */
    postNote(note: Eventlog) {
        if (note.event_type == 'Annotation') {
            note.entry_date = this.entry_date;
        }
        if (this.currentUser == null) {
            return;
        }
        note.event_owner_id = this.currentUser.user_id;
        note.content_id = this.titleToDisplay.content_id;
        this.eventlogService.postNote(note).then(res => this.getAuthorForNote(res.logs[0]))
            .then(note => {
                this.allNotes.push(note);
                this.notificationType = 'info';
                this.notificationTitle = 'Note added to title';
                this.notificationContent = note.event_type + ' has been added to the title.';
                this.createNotification();
            });
        this.showNoteForm = false;
    }
    /**
     * toggles the form to enter a new title request
     */
    displayRequestForm() {
        if (this.showRequestForm) {
            this.showRequestForm = false;
        } else {
            this.showRequestForm = true;
            if (this.customerList == null) {
                this.customerService.getCustomers()
                    .then(res => {
                        this.customerList = res.customers;
                    })

                    .catch(error => this.errorHandler(error));
            }
        }
    }
    /**
     * Adds a new request for the current title
     */
    addRequest() {
        this.custSelected = false;
        this.custAccountList = null;
        this.showRequestForm = false;
        if (this.titleToDisplay.content_requests) {
            for (const request of this.titleToDisplay.content_requests) {
                if (request.account_id == this.requestAccountId) {
                    this.notificationType = 'error';
                    this.notificationTitle = 'Error';
                    this.notificationContent = 'This title is already assigned to this account.';
                    this.createNotification();
                    return;
                }
            }
        }
        this.titleToDisplay.content_requests;
        const titleRequest = new TitleRequest();
        titleRequest.content_id = this.titleToDisplay.content_id;
        titleRequest.account_id = this.requestAccountId;
        this.titleRequestService.addRequest(titleRequest)
            .then(res => this.displayAddedRequest(res.pcRequests[0]));

    }
    /**
     * Displays the added request in the customer requests table and creates a notification to show request has been added
     */
    displayAddedRequest(request: any) {
        request = this.getAccountNameForRequest(request);
        this.allRequests.push(request);
        this.notificationType = 'info';
        this.notificationTitle = 'Request added';
        this.notificationContent = 'This title has been assigned to account: ' + request.accountName + '.';
        this.createNotification();
        return;
    }
    /**
     * Creates a new title or calls updateTitle to update the currently displayed title
     */
    save(title: any) {
        this.checkCatalogState(title);
        if (this.displayDet) {
            this.updateTitle(title);
        }
        else {
            this.titleService
                .createTitle(title).then(res => this.router.navigate(['/tms/titleDetails', title.content_id]));
        }
        this.titleToDisplay = null;
    }
    /**
     * updates the currently displayed title
     */
    updateTitle(title: any) {
        title.data_start_from = this.titleToDisplay.data_start_from;
        title.pdr_gen_start = this.titleToDisplay.pdr_gen_start;
        this.titleService
            .updateTitle(title, this.currentUser.user_id.toString())
            .then(res => this.displayDetails(res.titles[0]))
            .catch(error => this.errorHandler(error));

    }
    updateLastChecked() {
        const title: any = new Title();
        title.title_checked = true;
        title.content_id = this.titleToDisplay.content_id;
        this.titleService
            .updateTitle(title, this.currentUser.user_id.toString())
            .then(res => {
                this.titleToDisplay.last_checked_date = res.titles[0].last_checked_date;
                this.notificationType = 'info';
                this.notificationTitle = 'Last checked updated';
                this.notificationContent = 'The last checked date has been updated to today.';
                this.createNotification();
            })
            .catch(error => this.errorHandler(error));
    }
    /**
     * delets the current title
     */
    deleteTitle(title: Title) {
        this.titleToDisplay = null;
        this.titleService
            .deleteTitle(this.titleToDisplay).then(title => this.goBack());
    }

    /**
     * Go back to the titles page
     */
    goBack() {
        this.router.navigate(['/tms/titles']);
    }
    /**
     * Change catalog state from new to onboarding if any onboarding activites have been
     * performed
     */
    checkCatalogState(title: Title) {
        if (title.catalog_state == 1) {
            if (title.images_added == 1 || title.coremeta_added == 1 ||
                title.dsreq_met == 1 || title.pa_genes_added == 1) {
                title.catalog_state = 2;
            }
        }
    }
    /**
     * Gets a list of accounts for the given customer
     */
    getAccountsByCustomer(customer_id: number) {
        this.custSelected = true;
        this.custAccountList = this.allAccountList.filter(account => account.customer.customer_id == customer_id);

    }

    //options to be used for notifications
    public options = {
        timeOut: 5000,
        lastOnBottom: true,
        clickToClose: true,
        maxLength: 0,
        maxStack: 7,
        showProgressBar: true,
        pauseOnHover: true,
        preventDuplicates: false,
        preventLastDuplicates: 'visible',
        rtl: false,
        animate: 'scale',
        position: ['right', 'bottom']
    };


    createNotification() {
        switch (this.notificationType) {
            case 'success':
                this._service.success(this.notificationTitle, this.notificationContent);
                break;
            case 'error':
                this._service.error(this.notificationTitle, this.notificationContent);
                break;
            case 'info':
                this._service.info(this.notificationTitle, this.notificationContent);
                break;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/tms/title-create.component.ts